export const SN_Stored_Cards = 'storedCards'
export const ALL_CARDS = `${SN_Stored_Cards}/ALL_CARDS`
export const CUSTOMER_LOCATION = `${SN_Stored_Cards}/CUSTOMER_LOCATION`
